<div #sectionItem class="section-plus-x-more">
  {{ menu | productMenuBasicMethod: 'getNAdditionalItemsEndingText' : howManyAdditionalItems }}
</div>
